import { render, staticRenderFns } from "./SacListSortButton.vue?vue&type=template&id=0a54325c&scoped=true&"
import script from "./SacListSortButton.vue?vue&type=script&lang=js&"
export * from "./SacListSortButton.vue?vue&type=script&lang=js&"
import style0 from "./SacListSortButton.vue?vue&type=style&index=0&id=0a54325c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54325c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CRadio: require('@chakra-ui/vue').CRadio, CRadioGroup: require('@chakra-ui/vue').CRadioGroup, CBox: require('@chakra-ui/vue').CBox})
